 
import {
  applyImageFallback,
  resetImageFallback,
} from "@/utils/imageFallback";

const observers = new WeakMap();

function loadImage(el, src) {
  resetImageFallback(el);

  if (!src) {
    applyImageFallback(el);
    return;
  }

  // 失败后只切换一次占位图，绝不重新写入原 404 地址。
  el.onerror = () => applyImageFallback(el);
  el.src = src;
}

export default {
  install(app) {
    app.directive("lazys", {
      mounted(el, binding) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (!entry?.isIntersecting) return;
            loadImage(el, binding.value);
            observer.unobserve(el);
          },
          { threshold: 0 },
        );

        observers.set(el, observer);
        observer.observe(el);
      },
      updated(el, binding) {
        if (binding.value !== binding.oldValue) {
          loadImage(el, binding.value);
        }
      },
      unmounted(el) {
        observers.get(el)?.disconnect();
        observers.delete(el);
        el.onerror = null;
      },
    });
  },
};
